import { Ray, Spherical, Vector3 } from '@seddi/three';
import { normalizeAzimuth } from '@/core/spherical';
import { setFromBounds as setLookAtFromBounds } from './cameraLookAt';
export const animateLookAt = (() => {
    const dstOffset = new Vector3();
    const dstSpherical = new Spherical();
    const offset = new Vector3();
    const target = new Vector3();
    const targetDelta = new Vector3();
    const ray = new Ray();
    const spherical = new Spherical();
    return (self, lookAt, moveSpeed, rotateSpeed) => {
        const { distance: dstDistance, origin: dstOrigin, target: dstTarget } = lookAt;
        self.getWorldDirection(ray.direction);
        self.getWorldPosition(ray.origin);
        // Closest point to destination target along the ray.
        const origin = ray.origin;
        projectPoint(ray, dstTarget, target);
        // Move target.
        targetDelta.copy(dstTarget).sub(target).normalize();
        target.add(targetDelta.multiplyScalar(moveSpeed));
        if (target.distanceTo(dstTarget) < moveSpeed * 1.1) {
            target.copy(dstTarget);
        }
        // Smooth transition position cartesian coords path.
        // originDelta.copy(dstOrigin).sub(origin).normalize();
        // origin.add(originDelta.multiplyScalar(moveSpeed));
        // Smooth transition position spherical coords path.
        offset.copy(origin).sub(target);
        dstOffset.copy(dstOrigin).sub(dstTarget);
        spherical.setFromVector3(offset);
        dstSpherical.setFromVector3(dstOffset);
        // Phi (vertical rotation)
        const phiDiff = dstSpherical.phi - spherical.phi;
        if (Math.abs(phiDiff) < rotateSpeed * 1.1) {
            spherical.phi = dstSpherical.phi;
        }
        else {
            spherical.phi += phiDiff > 0 ? rotateSpeed : -rotateSpeed;
        }
        // Theta (horizontal rotation)
        // Skip theta animation at poles (phi near 0 or π) where theta is degenerate
        const POLE_THRESHOLD = 0.01;
        const atPole = dstSpherical.phi < POLE_THRESHOLD || dstSpherical.phi > Math.PI - POLE_THRESHOLD;
        if (atPole) {
            spherical.theta = dstSpherical.theta;
        }
        else {
            const thetaDiff = normalizeAzimuth(dstSpherical.theta - spherical.theta);
            if (Math.abs(thetaDiff) < rotateSpeed * 1.1) {
                spherical.theta = dstSpherical.theta;
            }
            else {
                spherical.theta += thetaDiff > 0 ? rotateSpeed : -rotateSpeed;
            }
        }
        // Distance (zoom)
        let distance = target.distanceTo(origin);
        const distDiff = dstDistance - distance;
        if (Math.abs(distDiff) < moveSpeed * 1.1) {
            distance = dstDistance;
        }
        else {
            distance += distDiff > 0 ? moveSpeed : -moveSpeed;
        }
        spherical.radius = distance;
        offset.setFromSpherical(spherical);
        origin.copy(target).add(offset);
        if (origin.distanceTo(dstOrigin) < moveSpeed * 1.1) {
            origin.copy(dstOrigin);
        }
        // Camera update.
        self.position.copy(origin);
        self.lookAt(target);
        // Return true when target is reached.
        if (origin.equals(dstOrigin) && target.equals(dstTarget)) {
            return true;
        }
        return false;
    };
})();
export function computeLookAtFromBounds(self, bounds, ref) {
    const { aspect: aspectRatio, fov } = self;
    setLookAtFromBounds(ref, bounds, fov, aspectRatio);
    return ref;
}
export function lookAt(self, target) {
    self.position.copy(target.origin);
    self.lookAt(target.target.x, target.target.y, target.target.z);
}
//
// Detail
//
/**
 * A + (dot(AP,AB) / dot(AB,AB)) * AB
 * When AB is unitary reduces to
 * A + dot(AP,AB) * AB
 */
const projectPoint = (function () {
    const ap = new Vector3();
    return (ray, p, target) => {
        const a = ray.origin;
        const ab = ray.direction;
        ap.copy(p).sub(a);
        target.copy(ab).multiplyScalar(ap.dot(ab)).add(a);
        return;
    };
})();
